/**
 * Shared qty error spacing (search + homepage product cards) and search-aligned messages.
 */
(function () {
  const MIN_PADDING = 40;

  function rsQtyI18nTpl(template, vars) {
    let t = template != null ? String(template) : '';
    const m = vars && typeof vars === 'object' ? vars : {};
    Object.keys(m).forEach((k) => {
      t = t.split(`%%${k}%%`).join(String(m[k]));
    });
    return t;
  }

  window.rsQtyValidationMessages = function rsQtyValidationMessages() {
    const L = window.__translations || {};
    return {
      invalid: L.coveo_search_qty_valid_quantity || 'Enter a valid quantity',
      minOrder: (count) =>
        rsQtyI18nTpl(L.coveo_search_qty_min_order_not_met || 'Minimum order quantity not met', { COUNT: count }),
      multiple: (count) =>
        rsQtyI18nTpl(L.coveo_search_qty_order_in_multiples || 'Must be in multiples of %%COUNT%%', { COUNT: count }),
    };
  };

  function updateQtyErrorWrapperPadding(wrapper, errorEl) {
    if (!wrapper || !errorEl) return;

    requestAnimationFrame(() => {
      const height = errorEl.offsetHeight;
      if (height > 0) {
        wrapper.style.paddingBottom = `${Math.max(height, MIN_PADDING)}px`;
      }
    });
  }

  function clearQtyErrorWrapperPadding(wrapper) {
    if (!wrapper) return;
    wrapper.classList.remove('has-qty-error');
    wrapper.style.removeProperty('padding-bottom');
  }

  window.rsQtyErrorSpacing = {
    MIN_PADDING,
    update(wrapper, errorEl) {
      if (!wrapper || !errorEl) return;
      wrapper.classList.add('has-qty-error');
      updateQtyErrorWrapperPadding(wrapper, errorEl);
    },
    clear: clearQtyErrorWrapperPadding,
  };

  function resolveQtyRulesFromInput(input) {
    const minParsed = parseInt(input.getAttribute('data-min') || input.min, 10);
    const stepParsed = parseInt(input.getAttribute('step'), 10);
    return {
      min: Number.isFinite(minParsed) && minParsed >= 1 ? minParsed : 1,
      step: Number.isFinite(stepParsed) && stepParsed >= 1 ? stepParsed : 1,
    };
  }

  function getQtyValidationMessage(input, rules) {
    const val = parseInt(input.value, 10);
    const msgs = window.rsQtyValidationMessages();

    if (Number.isNaN(val)) return msgs.invalid;
    if (val < rules.min) return msgs.minOrder(rules.min);
    if (rules.step > 1 && val % rules.step !== 0) return msgs.multiple(rules.step);
    return null;
  }

  window.rsValidateProductCardQtyInput = function rsValidateProductCardQtyInput(input) {
    if (!(input instanceof HTMLInputElement)) return null;
    if (input.closest('.rs-no-validate') || input.closest('.delivery-dates-modal')) return null;

    const wrapper = input.closest('.rs-quantity-input-wrapper');
    if (!wrapper || !input.closest('.rs-buy-buttons-block')) return null;

    const rules = resolveQtyRulesFromInput(input);

    // If the field was cleared, reset to min order qty instead of showing an error
    const currentVal = parseInt(input.value, 10);
    if (isNaN(currentVal) || input.value.trim() === '') {
      input.value = String(rules.min);
    }

    const errorBox = wrapper.querySelector('.rs-error__message');
    const errorText = wrapper.querySelector('.rs-error__message-text, .rs-input__error span');
    const message = getQtyValidationMessage(input, rules);

    if (message) {
      if (errorText) errorText.textContent = message;
      wrapper.classList.add('rs-error');
      wrapper.closest('product-form-component')?.classList.add('rs-error');
      if (errorBox instanceof HTMLElement) errorBox.style.display = '';
      window.rsQtyErrorSpacing.update(wrapper, errorBox);
      return false;
    }

    wrapper.classList.remove('rs-error');
    wrapper.closest('product-form-component')?.classList.remove('rs-error');
    if (errorText) errorText.textContent = '';
    window.rsQtyErrorSpacing.clear(wrapper);
    return true;
  };

  document.addEventListener(
    'input',
    (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.classList.contains('rs-quantity-input')) {
        window.rsValidateProductCardQtyInput(target);
      }
    },
    true
  );
})();
